// Libraries
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import AddIcon from '@mui/icons-material/Add';

// Core
import { ResourceTextApplication } from '../../core/resources';

// Common
import { AActionButton, ADefaultButton, AButtonBaseProps } from '../../common/buttons';

export interface AAddButtonProps extends Omit<AButtonBaseProps, 'children'> {
    children?: ReactNode;
    type?: 'action' | 'default';
}

export default function AAddButton(props: AAddButtonProps) {
    const { t } = useTranslation<ResourceTextApplication[]>(['AnelmaGeneral']);
    const { children, type, ...actionButtonProps } = props;
    const children2 = children ? children : t('AnelmaGeneral:1072');

    if (type === 'action')
        return <AActionButton {...actionButtonProps} children={children2} icon={<AddIcon />} />;
    return <ADefaultButton {...actionButtonProps} children={children2} icon={<AddIcon />} />;
}
